import React from 'react';

export const WEATHER_META = {
  mist: { label: 'Mist', glyph: 'M3 10h14M5 14h12M7 18h8' },
  snow: { label: 'Snowfall', glyph: 'M12 4v16M6 8l12 8M18 8L6 16' },
  golden_hour: { label: 'Golden hour', glyph: 'M12 14a4 4 0 100-8 4 4 0 000 8zM4 18h16' },
  rain: { label: 'Rain', glyph: 'M8 14v4M12 15v4M16 14v4M6 10a6 6 0 0112 0' },
  aurora: { label: 'Aurora', glyph: 'M4 16c2-6 4-6 6 0s4 6 6 0 3-8 4-4' },
  clear_stars: { label: 'Clear stars', glyph: 'M12 5l1 2.5L15.5 8 13 9l-1 2.5L11 9 8.5 8 11 7.5zM18 14l.6 1.4 1.4.6-1.4.6L18 18l-.6-1.4-1.4-.6 1.4-.6zM6 15l.6 1.4 1.4.6-1.4.6L6 19l-.6-1.4L4 17l1.4-.6z' },
};

export const WeatherHint = ({ tone, color = '#787488' }) => {
  const meta = WEATHER_META[tone];
  if (!meta) return null;
  return (
    <span className="inline-flex items-center gap-1.5" data-testid={`weather-hint-${tone}`}>
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round">
        <path d={meta.glyph} />
      </svg>
      <span className="text-[11px]" style={{ fontFamily: 'Jost, sans-serif', color }}>{meta.label}</span>
    </span>
  );
};
